import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { environment } from 'src/environments/environment';
import { StihlUserDTO } from "../models/stihl-user-dto";

@Injectable({
  providedIn: 'root'
})

export class UserService {
  private pathAPI = environment.urlAPI;
  private controller = "StihlUser/";

  public userData = new BehaviorSubject<StihlUserDTO>(null);

  constructor(private http: HttpClient) {
    this.initializeUserData();
  }

  public get(id: string): Observable<StihlUserDTO> {
    return this.http.get<StihlUserDTO>(this.pathAPI + this.controller + id);
  }

  public getUserInfo(): Observable<StihlUserDTO> {    
    return this.http.get<StihlUserDTO>(this.pathAPI + this.controller + 'GetLoggedUserInfo');
  }

  public initializeUserData() {
    const that = this;
    this.getUserInfo().subscribe(resp => {
      that.setUserData(resp);
    });    
  }

  getUserData(): Observable<StihlUserDTO> {    
    return this.userData.asObservable();
  }

  setUserData(user: StihlUserDTO) {
    this.userData.next(user);
  }

}
